import React, { useState, useEffect } from 'react';
import Dropzone from 'react-dropzone';
import trashIcon from '../../assets/img/icons/trash.svg';
import defaultIcon from '../../assets/img/icons/file_default.svg';
import downloadIcon from '../../assets/img/fromhtmls/download_icon.png';
import fileImageIcon from '../../assets/img/icons/file_image.svg';
import fileDocumentIcon from '../../assets/img/icons/file_document.svg';

export default function AllFilesDropOnly(props) {
  var { className, insideImage, insideImageStyle, insideText, accept } = props;
  // console.log('====================');

  const onDropFile = files => {
    let file = files[0];
    // console.log('file :- ', file);
    let reader = new FileReader();
    reader.onloadend = () => {
      var item = reader.result;
      var data = { file: item, filename: file.name.replace(/ /g, '-') };
      // console.log('data :- ', data);
      props.onFileSave(data);
      props.onFileChnageLocally(true);
    };
    reader.readAsDataURL(file);
  };

  return (
    <>
      <Dropzone
        onDrop={onDropFile}
        accept={accept ? accept : ''}
        multiple={false}
      >
        {({ getRootProps, getInputProps }) => (
          // <section className={`${hideDropZoneClass}`}>
          <div {...getRootProps()} className={`${className}`}>
            <input {...getInputProps()} />
            <img src={insideImage} style={insideImageStyle} />
            <span className="custom-text1-normal-secondary">{insideText}</span>
          </div>
          // </section>
        )}
      </Dropzone>
    </>
  );
}
